/**
 * Shared animation configurations for consistent motion design
 * Using Framer Motion animation variants and transitions
 */

export const animations = {
  // Spring presets for different use cases
  spring: {
    // Soft spring - for large movements and page transitions
    soft: { type: "spring" as const, stiffness: 500, damping: 35 },
    // Medium spring - for dropdowns, modals, and general UI
    medium: { type: "spring" as const, stiffness: 600, damping: 30 },
    // Stiff spring - for quick, snappy interactions
    stiff: { type: "spring" as const, stiffness: 500, damping: 30 },
    // Bouncy spring - for playful success states
    bouncy: { type: "spring" as const, stiffness: 260, damping: 20 },
  },

  // Common animation variants
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  },

  slideUp: {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -10 },
  },

  slideDown: {
    initial: { opacity: 0, y: -10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 10 },
  },

  slideLeft: {
    initial: { opacity: 0, x: 20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -20 },
  },

  slideRight: {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 20 },
  },

  scale: {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
  },

  scaleRotate: {
    initial: { opacity: 0, scale: 0, rotate: -180 },
    animate: { opacity: 1, scale: 1, rotate: 0 },
    exit: { opacity: 0, scale: 0, rotate: 180 },
  },

  // Button interaction animations
  button: {
    tap: { scale: 0.98 },
    hover: { scale: 1.01 },
  },

  // Stagger configurations for lists
  stagger: {
    container: {
      hidden: { opacity: 0 },
      show: {
        opacity: 1,
        transition: {
          staggerChildren: 0.05,
        },
      },
    },
    item: {
      hidden: { opacity: 0, y: 20 },
      show: { opacity: 1, y: 0 },
    },
  },

  // Duration presets
  duration: {
    fast: 0.15,
    medium: 0.25,
    slow: 0.35,
  },
};
